import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";
import {DialogService} from "../../services/dialog.service";

@Component({
  selector: 'micro-auditReportMonth',
  templateUrl: './auditReportMonth.component.html'
})
export class AuditReportMonthComponent implements OnInit, OnChanges {

  @Input()
  year:any;

  @Input()
  month:any;

  @Input()
  showLink:boolean = true;

  reports:any;

  downloadLink:any;
  loading:boolean = false;

  constructor(public auth: AuthService,
              private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              public dialogService:DialogService,
              private alertService:AlertService) {
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.genPreviewLink();
    this.loadReport();
  }

  genPreviewLink() {
    this.downloadLink = `${this.env.e.url}/pay/financialAudits/generate?year=${this.year}&month=${this.month}&access_token=${this.auth.getAccessToken()}`;
  }

  loadReport() {
    if (this.loading) {
      return;
    }

    let params:HttpParams = new HttpParams()
      .set('year', this.year)
      .set('month', this.month)
    ;

    this.loading = true;
    this.http.get(`${this.env.e.url}/pay/accounts/auditReport`, {params: params}).subscribe(
      data => {
        this.reports = data;
        this.loading = false;
      }
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'year' || prop === 'month') {
        this.load();
      }
    }
  }
}
